module.exports = __webpack_public_path__ + "img/2-01-04-adp-fit-4-life.b5ef1d5c.svg";